import compressPdf from 'assets/img/icons/50px/compressPdf.svg';
import editPdf from 'assets/img/icons/50px/editPdf.svg';
import imagesPdf from 'assets/img/icons/50px/image-to-pdf.svg';
import imageToText from 'assets/img/icons/50px/images-to-text.svg';
import mergePdf from 'assets/img/icons/50px/mergePdf.svg';
import ocr from 'assets/img/icons/50px/ocr.svg';
import pdfConverter from 'assets/img/icons/50px/pdf-converter.svg';
import pdfExel from 'assets/img/icons/50px/pdf-exel.svg';
import pdfJpg from 'assets/img/icons/50px/pdf-jpg.svg';
import pdfPng from 'assets/img/icons/50px/pdf-png.svg';
import pdfPtt from 'assets/img/icons/50px/pdf-ptt.svg';
import pdfWord from 'assets/img/icons/50px/pdf-word.svg';
import sign from 'assets/img/icons/50px/sign.svg';
import splitPdf from 'assets/img/icons/50px/splitPdf.svg';
import wordPdf from 'assets/img/icons/50px/word-pdf.svg';

import type { ButtonIcon } from 'components/buttons/icon-button';

import { PAGE_LINKS } from 'ts/constants/page-links';
import { InternalFileType } from 'ts/types/file';

type Link = {
  label: string;
  href: string;
  icon: ButtonIcon;
  img: string;
  from: InternalFileType;
  to?: InternalFileType;
};

export type DropDownList = {
  label: string;
  links: Link[];
};

export const getConversionLinks = (t: (key: string) => string): DropDownList => {
  return {
    label: t('links.from.label'),
    links: [
      {
        label: t('links.from.pdf_to_word'),
        href: PAGE_LINKS.PDF_TO_WORD,
        icon: 'word',
        img: pdfWord,
        from: InternalFileType.PDF,
        to: InternalFileType.DOC
      },
      {
        label: t('links.from.pdf_to_png'),
        href: PAGE_LINKS.PDF_TO_PNG,
        icon: 'png',
        img: pdfPng,
        from: InternalFileType.PDF,
        to: InternalFileType.PNG
      },
      {
        label: t('links.from.pdf_to_epub'),
        href: PAGE_LINKS.PDF_TO_EPUB,
        icon: 'epub',
        img: wordPdf,
        from: InternalFileType.PDF,
        to: InternalFileType.EPUB
      },
      {
        label: t('links.from.pdf_to_jpg'),
        href: PAGE_LINKS.PDF_TO_JPG,
        icon: 'img',
        img: pdfJpg,
        from: InternalFileType.PDF,
        to: InternalFileType.JPG
      },
      {
        label: t('links.from.pdf_to_pptx'),
        href: PAGE_LINKS.PDF_TO_PPTX,
        icon: 'ptt',
        img: pdfPtt,
        from: InternalFileType.PDF,
        to: InternalFileType.PPTX
      },
      {
        label: t('links.from.pdf_to_excel'),
        href: PAGE_LINKS.PDF_TO_EXCEL,
        icon: 'spreadsheets',
        img: pdfExel,
        from: InternalFileType.PDF,
        to: InternalFileType.XLS
      },
      {
        label: t('links.to.word_to_pdf'),
        href: PAGE_LINKS.WORD_TO_PDF,
        icon: 'word',
        img: pdfWord,
        from: InternalFileType.DOC,
        to: InternalFileType.PDF
      },
      {
        label: t('links.to.images_to_pdf'),
        href: PAGE_LINKS.IMAGE_TO_PDF,
        icon: 'img',
        img: imagesPdf,
        from: InternalFileType.IMAGE,
        to: InternalFileType.PDF
      },
      {
        label: t('links.to.jpg_to_pdf'),
        href: PAGE_LINKS.JPG_TO_PDF,
        icon: 'img',
        img: pdfJpg,
        from: InternalFileType.JPG,
        to: InternalFileType.PDF
      },
      {
        label: t('links.to.png_to_pdf'),
        href: PAGE_LINKS.PNG_TO_PDF,
        icon: 'png',
        img: pdfPng,
        from: InternalFileType.PNG,
        to: InternalFileType.PDF
      },
      {
        label: t('links.to.image_to_text'),
        href: PAGE_LINKS.IMAGE_TO_TEXT,
        icon: 'img',
        img: imageToText,
        from: InternalFileType.IMAGE,
        to: InternalFileType.TEXT
      },
      {
        label: t('links.to.pdf_converter'),
        href: PAGE_LINKS.PDF_CONVERTER,
        icon: 'pdf-converter',
        img: pdfConverter,
        from: InternalFileType.IMAGE,
        to: InternalFileType.PDF
      }
    ]
  };
};

export const getLinksTools = (t: (key: string) => string): DropDownList => {
  return {
    label: t('links.tools.label'),
    links: [
      {
        label: t('links.tools.edit_pdf'),
        href: PAGE_LINKS.EDIT_PDF,
        icon: 'edit-fill',
        img: '',
        from: InternalFileType.PDF
      },
      {
        label: t('links.security.signature_pdf'),
        href: PAGE_LINKS.SIGNATURE_PDF,
        icon: 'signature',
        img: sign,
        from: InternalFileType.PDF
      },
      {
        label: t('links.tools.compress_pdf'),
        href: PAGE_LINKS.COMPRESS_PDF,
        icon: 'compress',
        img: '',
        from: InternalFileType.PDF
      },
      {
        label: t('links.merge_split.merge_pdf'),
        href: PAGE_LINKS.MERGE_PDF,
        icon: 'merge',
        img: mergePdf,
        from: InternalFileType.PDF
      },
      {
        label: t('links.merge_split.split_pdf'),
        href: PAGE_LINKS.SPLIT_PDF,
        icon: 'split',
        img: splitPdf,
        from: InternalFileType.PDF
      },
      {
        label: t('links.merge_split.delete_pages_from_pdf'),
        href: PAGE_LINKS.DELETE_PAGES_FROM_PDF,
        icon: 'merge',
        img: splitPdf,
        from: InternalFileType.PDF
      }
    ]
  };
};

export const getLinksAdvancedTools = (t: (key: string) => string): DropDownList => {
  return {
    label: t('links.tools.advanced_tools'),
    links: [
      {
        label: t('links.tools.pdf_ocr'),
        href: PAGE_LINKS.PDF_OCR,
        icon: 'ocr',
        img: ocr,
        from: InternalFileType.PDF
      },
      {
        label: t('links.tools.translate'),
        href: PAGE_LINKS.TRANSLATE_PDF,
        icon: 'translate',
        img: ocr,
        from: InternalFileType.PDF
      },
      {
        label: t('links.tools.merge_images'),
        href: PAGE_LINKS.MERGE_IMGS,
        icon: 'merge',
        img: mergePdf,
        from: InternalFileType.IMAGE,
        to: InternalFileType.PDF
      }
    ]
  };
};

export const getLinksCompress = (t: (key: string) => string): DropDownList => {
  return {
    label: t('links.tools.label'),
    links: [
      {
        label: t('links.tools.compress_pdf'),
        href: PAGE_LINKS.COMPRESS_PDF,
        icon: 'compress',
        img: compressPdf,
        from: InternalFileType.PDF
      }
    ]
  };
};

export const getLinksEditPdf = (t: (key: string) => string): DropDownList => {
  return {
    label: t('links.tools.label'),
    links: [
      {
        label: t('links.tools.edit_pdf'),
        href: PAGE_LINKS.EDIT_PDF,
        icon: 'edit-fill',
        img: editPdf,
        from: InternalFileType.PDF
      }
    ]
  };
};
